import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { Eye } from "lucide-react";
import { muiTheme } from "@/styles/theme";
import ResponsiveEditDialog from "@/modules/common/components/modals/responsive-edit-dialog";
import { getQuarter } from "date-fns";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import TargetsConfigurationsTable from "@/modules/targets/components/target-configurations/targets-configurations-table";
import ResponsiveTabs from "@/modules/common/components/ui/responsive-tabs";

const quartersData: {
  value: number;
  label: string;
}[] = [
  { value: 1, label: "Q1" },
  { value: 2, label: "Q2" },
  { value: 3, label: "Q3" },
  { value: 4, label: "Q4" },
];

const OpenViewQuartelyTarget = ({
  handleChange,
  quarter,
  year,
}: {
  handleChange: (quarter: 1 | 2 | 3 | 4) => void;
  quarter: 1 | 2 | 3 | 4;
  year: number;
}) => {
  const quarters = quartersData.filter((q) => {
    if (year === new Date().getFullYear()) {
      return q.value <= getQuarter(new Date());
    }
    return true;
  });

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { isMobile } = useScreenSize();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 1,
          padding: "10px 16px",
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor:
              muiTheme.colorSchemes.light.palette.main.actionDisabled,
          },
        }}
        onClick={handleOpen}
      >
        <Eye
          style={{
            color: muiTheme.colorSchemes.light.palette.primary[500],
            width: "20px",
            height: "20px",
          }}
        />
        <Typography
          sx={{
            color: "#015C9A",
          }}
          variant="h5_bold"
        >
          View Quarterly Target
        </Typography>
      </Box>

      <ResponsiveEditDialog
        open={open}
        setOpen={handleClose}
        handleCloseModal={handleClose}
        header={`${new Date().getFullYear()} Q${getQuarter(
          new Date()
        )}, ${new Date().toLocaleString("default", { month: "long" })}`}
        hideModalFooter
        modalFooter={false}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: isMobile ? "100%" : "800px",
          }}
        >
          <ResponsiveTabs
            tabs={quarters}
            selectedTab={quarter}
            handleChange={(value) => {
              if (value >= 1 && value <= 4) {
                handleChange(value as 1 | 2 | 3 | 4);
              }
            }}
          />
          <TargetsConfigurationsTable quarter={quarter} year={year} viewOnly />
        </Box>
      </ResponsiveEditDialog>
    </>
  );
};

export default OpenViewQuartelyTarget;
